export const isMobileIOSDevice = (): boolean => {
  return Boolean(navigator?.userAgent?.match(/iPhone/i) || navigator.userAgent.match(/iPod/i));
};
